<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="专家组确认" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <!-- <a-button :loading="loading || saving" type="primary" @click="zjdfmxEdit">专家打分明细</a-button> -->
                <a-button :loading="loading || saving" v-if="editData.djzt === '确认'" type="danger" @click="onCancel">撤销</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="评审表编号">
                                            <a-input ref="cgysbbh" v-model="editData.cgysbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报表编号">
                                            <a-input ref="cgsbbbh" v-model="editData.cgsbbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报日期">
                                            <a-date-picker
                                                ref="sbrq"
                                                v-model="editData.sbrq"
                                                width="100%"
                                                valueFormat="YYYY-MM-DD"
                                                style="width:100%"
                                                disabled
                                            />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报年份">
                                            <FGDictSelectCN ref="sbnf" dictNo="P0002" v-model="editData.sbnf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="申报单位编号">
                                            <a-input ref="sbdwbh" v-model="editData.sbdwbh" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6">
                                        <a-form-item label="申报单位名称">
                                            <a-input ref="sbdwmc" v-model="editData.sbdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="单位类别">
                                            <a-input ref="dwlb" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item class="formlabelnewline" :label="'工程咨询单位  \n备案编号'">
                                            <a-input ref="babh" v-model="editData.babh" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="地址">
                                            <a-input ref="xxdz" v-model="editData.xxdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="邮政编码">
                                            <a-input ref="yzbm" v-model="editData.yzbm" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6">
                                        <a-form-item label="成果名称">
                                            <a-input ref="xmmc" v-model="editData.xmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专业名称">
                                            <a-input ref="zymc" v-model="editData.zymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果类型">
                                            <a-input ref="cglx" v-model="editData.cglx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="申报等级">
                                            <a-input ref="cgsbdj" v-model="editData.cgsbdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="项目密级">
                                            <a-input ref="xmmj" v-model="editData.xmmj" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6">
                                        <a-form-item label="成果开始时间">
                                            <a-input ref="cgkssj" v-model="editData.cgkssj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="成果完成时间">
                                            <a-input ref="cgwcsj" v-model="editData.cgwcsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!-- <a-col :span="6">
                                        <a-form-item label="成果参与人员">
                                            <a-input ref="cgcyry" v-model="editData.cgcyry" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="委托单位">
                                            <a-input ref="wtdw" v-model="editData.wtdw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="是否涉密">
                                            <a-input ref="sfsm" v-model="editData.sfsm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="服务范围">
                                            <a-input ref="fwfw" v-model="editData.fwfw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="项目总投资(万元)">
                                            <a-input ref="xmztz" v-model="editData.xmztz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="规划级别">
                                            <a-input ref="ghjb" v-model="editData.ghjb" disabled />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="6">
                                        <a-form-item label="所属分组">
                                            <a-input ref="ssfz" v-model="editData.ssfz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="合规审核人员">
                                            <a-input ref="hgshry" v-model="editData.hgshry" disabled />
                                        </a-form-item>
                                    </a-col>

                                    <a-col :span="6">
                                        <a-form-item label="审核结论">
                                            <a-input ref="shjl" v-model="editData.shjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="录入日期">
                                            <a-date-picker ref="lrrq" v-model="editData.lrrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="评审专家">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专家类型">
                                            <a-input ref="zjlx" v-model="editData.zjlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专家单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'其他主要  \n完成单位'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="qtzywcdw" v-model="editData.qtzywcdw" disabled :rows="1" />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="6">
                                        <a-form-item label="评审状态">
                                            <a-input ref="pszt" v-model="editData.pszt" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="初审结果">
                                            <FGDictSelectCN ref="csjg" dictNo="CG200101" v-model="editData.csjg" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="初审得分">
                                            <a-input-number ref="csdf" v-model="editData.csdf" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                                            <a-button type="link" @click="zjdfmxEdit">专家打分明细</a-button>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="复核意见">
                                            <FGDictSelectCN ref="fhyj" dictNo="CG300102" v-model="editData.fhyj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="复核结果">
                                            <FGDictSelectCN ref="fhjg" dictNo="CG200101" v-model="editData.fhjg" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="复核得分">
                                            <a-input-number ref="fhdf" v-model="editData.fhdf" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="6" v-if="editData.fhyj === '不同意'">
                                        <a-form-item label="" :label-col="{ span: 0 }" :wrapper-col="{ span: 24 }">
                                            <a-button type="link" @click="openFhdfmxView">复核打分明细</a-button>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="6">
                                        <a-form-item label="专家组意见">
                                            <FGDictSelectCN ref="zjzyj" dictNo="ZJ200301" v-model="editData.zjzyj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="专家组结论">
                                            <FGDictSelectCN ref="zjzjg" dictNo="CG200101" v-model="editData.zjzjg" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="6">
                                        <a-form-item label="组内排名">
                                            <a-input-number ref="znpm" v-model="editData.znpm" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 6]">
                                    <!-- <a-col :span="12">
                                        <a-form-item label="成果概况" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="cggk" v-model="editData.cggk" disabled :rows="3" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="成果应用情况" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
                                            <a-textarea ref="cgyyqk" v-model="editData.cgyyqk" disabled :rows="3" />
                                        </a-form-item>
                                    </a-col> -->
                                    <a-col :span="24">
                                        <a-form-item label="结论说明" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="qryj" :rows="3" v-model="editData.qryj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <!--                                    <a-col :span="24">
                                        <a-form-item label="复核意见说明" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="fhyjsm" :rows="5" v-model="editData.fhyjsm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="初审意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="csyj" :rows="5" v-model="editData.csyj" disabled />
                                        </a-form-item>
                                    </a-col>-->
                                    <a-col :span="24">
                                        <a-form-item label="内容提要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="nrty" v-model="editData.nrty" disabled :rows="10" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'成果特点及  \n申报理由'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="cgtdjsbly" :rows="10" v-model="editData.cgtdjsbly" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'审批(核准)  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="spyjzy" v-model="editData.spyjzy" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'评估(评审、审查)  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="pgyjzy" :rows="2" v-model="editData.pgyjzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item
                                            class="formlabelnewline"
                                            :label="'评价、鉴定  \n意见摘要'"
                                            :label-col="{ span: 2 }"
                                            :wrapper-col="{ span: 22 }"
                                        >
                                            <a-textarea ref="pjjdyjzy" v-model="editData.pjjdyjzy" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="其他摘要" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="qtzy" :rows="2" v-model="editData.qtzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="申报单位意见" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="sbdwyj" v-model="editData.sbdwyj" disabled :rows="2" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
                                            <a-textarea ref="bz" :rows="2" v-model="editData.bz" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 初审专家评分明细 -->
                        <FGCollapsiblePanel title="初审专家评分明细">
                            <vxe-table
                                ref="DFMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataDFMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                                <vxe-table-column field="csdf" title="初审得分" width="150"></vxe-table-column>
                                <vxe-table-column field="csjg" title="初审结果" width="150"></vxe-table-column>
                                <vxe-table-column field="csyj" title="初审意见" min-width="100"></vxe-table-column>
                                <vxe-table-column title="" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="zjdfmxEdit1(scope.row)">专家打分明细</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果资料明细表格 -->
                        <FGCollapsiblePanel title="成果资料明细">
                            <vxe-table
                                ref="ZLMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataZLMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                                <vxe-table-column field="zlmc" title="资料名称" width="300"></vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="100"></vxe-table-column>
                                <vxe-table-column title="附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="attachShow_zlmx(scope.row)">相关资料</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果获奖情况明细表格 -->
                        <FGCollapsiblePanel title="成果获奖情况明细">
                            <vxe-table
                                ref="HJQKMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataHJQKMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="hjsj" title="获奖时间" width="150" align="center"></vxe-table-column>
                                <vxe-table-column field="jlmc" title="奖励名称" width="300"></vxe-table-column>
                                <vxe-table-column field="jldj" title="等级" width="120" align="center"></vxe-table-column>
                                <vxe-table-column field="jjse" title="奖金数额(元)" width="110" header-align="center" align="right">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatNumber(row.jjse, "0.00") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="sjbm" title="授奖部门" min-width="100"></vxe-table-column>
                                <vxe-table-column title="附件" width="150" align="center">
                                    <template v-slot="scope">
                                        <span class="btn_edit" @click="attachShow_hjqk(scope.row)">相关材料</span>
                                    </template>
                                </vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 成果完成人情况明细表格 -->
                        <FGCollapsiblePanel title="成果主要完成人情况明细">
                            <vxe-table
                                ref="WCRMXitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataWCRMX"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="xm" title="姓名" width="120" align="center"></vxe-table-column>
                                <vxe-table-column field="xb" title="性别" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="nl" title="年龄" width="100" align="center"></vxe-table-column>
                                <vxe-table-column field="zc" title="职称" width="200"></vxe-table-column>
                                <vxe-table-column field="gzdw" title="工作单位" min-width="100"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachDownload ref="attachdown" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
                <AttachModalDownload :attachCfg.sync="attachProps_zlmx" />
                <AttachModalDownload :attachCfg.sync="attachProps_hjqk" />
            </a-layout>
        </a-page-header>
        <ZjdfmxForm :showEdit.sync="editProps.showEdit" :dataId="editProps.dataId" :zjdfblx="editProps.zjdfblx" @dataUpdated="loadData" />
        <FhdfmxForm :showEdit.sync="editProps2.showEdit" :dataId="editProps2.dataId" :zjdfblx="editProps2.zjdfblx" @dataUpdated="loadData" />
    </div>
</template>

<script>
import ZjdfmxForm from "./ZjdfmxForm";
import FhdfmxForm from "./FhdfmxForm";
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "ZjzqrView",
    components: { ZjdfmxForm, FhdfmxForm },
    props: ["showView", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            dateFormat: "YYYY-MM-DD",
            saving: false,
            isShow1: false,
            isShow2: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            editItemDataYSBMX: [],
            editItemDataYSBMXLoading: false,
            editItemDataZLMX: [],
            editItemDataZLMXLoading: false,
            editItemDataDFMX: [],
            editItemDataDFMXLoading: false,
            editItemDataHJQKMX: [],
            editItemDataHJQKMXLoading: false,
            editItemDataWCRMX: [],
            editItemDataWCRMXLoading: false,
            attachProps_zlmx: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_ZLMX",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            attachProps_hjqk: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_HJQK",
                fkfield: "ID",
                attachSource: "CG1001"
            },
            editProps: {
                showEdit: false,
                dataId: null,
                zjdfblx: null
            },
            editProps2: {
                showEdit: false,
                dataId: null,
                zjdfblx: null
            }
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return "查看";
        },
        // 是否显示编辑界面
        viewIsVisible: {
            get() {
                return this.showView;
            },
            set(newVal) {
                this.$emit("update:showView", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        },
        attachCfg() {
            return {
                fktable: "CG_CGSBB",
                fkvalue: this.editData.lydjid,
                attachsource: "CG1001"
            };
        }
    },
    activated() {
        // 修改，加载数据
        this.loadData();
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.csjg.focus();
        });
    },
    methods: {
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/selectByCGSBMXId",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载明细数据
                            this.loadItemDataYSBMX();
                            // 加载资料明细数据
                            this.loadItemDataZLMX();
                            // 加载获奖情况明细数据
                            this.loadItemDataHJQKMX();
                            // 加载完成人明细数据
                            this.loadItemDataWCRMX();
                            // 加载打分明细
                            this.loadItemDataDFMX();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.viewIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.viewIsVisible = false;
                    }
                });
        },
        loadItemDataYSBMX() {
            this.editItemDataYSBMX = [];
            this.editItemDataYSBMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgcsgl/listItemYSBMX",
                    {
                        cgysbid: this.editDataId,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataYSBMXLoading = false;
                    if (success) {
                        this.editItemDataYSBMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataZLMX() {
            this.editItemDataZLMX = [];
            this.editItemDataZLMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemZlmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZLMXLoading = false;
                    if (success) {
                        this.editItemDataZLMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataDFMX() {
            this.editItemDataDFMX = [];
            this.editItemDataDFMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemCsdfmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataDFMXLoading = false;
                    if (success) {
                        this.editItemDataDFMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataHJQKMX() {
            this.editItemDataHJQKMX = [];
            this.editItemDataHJQKMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemHjqkmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataHJQKMXLoading = false;
                    if (success) {
                        this.editItemDataHJQKMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataWCRMX() {
            this.editItemDataWCRMX = [];
            this.editItemDataWCRMXLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemWcrqkmx",
                    {
                        cgsbbmxid: this.editData.lydjmxid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataWCRMXLoading = false;
                    if (success) {
                        this.editItemDataWCRMX = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        //撤销
        onCancel() {
            this.$FG_message.confirm("P0000", "撤销").then((type) => {
                if (type === "ok") {
                    this.editDataLoading = true;
                    this.$FG_http
                        .post("./api/main/zxcggl/cgcsgl/unConfirm", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.saving = false;
                            if (success) {
                                // 设置当前行
                                this.lookDataId = this.editData.id;
                                // 返回列表
                                this.viewIsVisible = false;
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.viewIsVisible = false;
        },
        // 附件管理
        attachShow_zlmx(row) {
            // 设置编辑记录id
            this.attachProps_zlmx.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_zlmx.visible = true;
        },
        // 附件管理
        attachShow_hjqk(row) {
            // 设置编辑记录id
            this.attachProps_hjqk.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps_hjqk.visible = true;
        },
        // 专家打分明细
        zjdfmxEdit() {
            // 设置编辑记录id
            this.editProps.dataId = this.editData.id;
            this.editProps.zjdfblx = this.editData.zjdfblx;
            // 显示编辑窗口
            this.editProps.showEdit = true;
        },
        // 专家打分明细列表中
        zjdfmxEdit1(row) {
            // 设置编辑记录id
            this.editProps.dataId = row.id;
            this.editProps.zjdfblx = row.zjdfblx;
            // 显示编辑窗口
            this.editProps.showEdit = true;
        },
        // 复核打分明细
        openFhdfmxView() {
            // 设置编辑记录id
            this.editProps2.dataId = this.editData.id;
            this.editProps2.zjdfblx = this.editData.zjdfblx;
            // 显示编辑窗口
            this.editProps2.showEdit = true;
        }
    }
};
</script>
<style lang="scss" scoped></style>
